<template>
  <div
    class="toggle-lang"
    v-clickoutside="handleClose">
    <!-- 已选择的语言 -->
    <div
      class="toggle-box"
      @click="selected = !selected"
      @mouseover="handleIconHover(true)"
      @mouseout="handleIconHover(false)">
      <div class="lang-logo">
        <img
          :src="selectedLogo"
          :alt="$i18n.locale">
      </div>
      <div class="icon-box">
        <AliIcon
          class="icon"
          v-show="!selected"
          :name="hoverIcon"/>
        <AliIcon
          class="icon"
          v-show="selected"
          name="xiangshang-bai"/>
      </div>
    </div>
    <!-- 可选择的语言 -->
    <transition name="el-zoom-in-top">
      <ul
        class="mount-box"
        v-show="selected">
        <li
          v-for="item in langList"
          :key="item.lang"
          class="mount-item"
          :class="$i18n.locale === item.lang ? 'active' : ''"
          @click="handleSelectLang(item)">
          <img
            :src="item.logo"
            :alt="item.lang">
          <span>{{ $t(item.text) }}</span>
          <AliIcon
            class="icon"
            v-show="$i18n.locale === item.lang"
            name="xuanzhong1"/>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import cnLogo from '@/assets/image/login/cn.png'
import enLogo from '@/assets/image/login/en.png'
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      selected: false,
      langList: [{
        lang: 'zh-CN',
        logo: cnLogo,
        text: '中文'
      }, {
        lang: 'en',
        logo: enLogo,
        text: '英文'
      }],
      iconHover: false
    }
  },
  computed: {
    ...mapState('app', ['lang']),
    selectedLogo () {
      const index = this.langList.findIndex(item => item.lang === this.$i18n.locale)
      return this.langList[index].logo
    },
    hoverIcon () {
      return this.iconHover ? 'xiangxia-bai' : 'xiangxia-hui'
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations('app', ['SET_LANG']),
    handleIconHover (type) {
      this.iconHover = type
    },
    handleSetLang ({ lang, logo }) {
      this.selected = false
      // 修改i18n及storage中的语言
      this.$i18n.locale = lang || 'zh-CN'
      this.SET_LANG(lang || 'zh-CN')
    },
    handleSelectLang ({ lang, logo }) {
      if (this.$i18n.locale === lang) {
        return
      }
      this.handleSetLang({ lang, logo })
    },
    handleClose () {
      this.selected = false
    }
  }
}
</script>

<style scoped lang="less">
.toggle-lang {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  user-select: none;
  .toggle-box {
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 41px;
    .lang-logo {
      width: 20px;
      height: 20px;
      margin-right: 9px;

      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .icon-box {
      display: flex;
      align-items: center;
      width: 10px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      > .icon {
        width: 10px;
        height: 7px;
      }
    }
  }
  .mount-box {
    position: absolute;
    top: 64px;
    right: 0;
    z-index: 999;
    > .mount-item {
      position: relative;
      display: flex;
      align-items: center;
      width: 120px;
      height: 40px;
      background: @blueLess80;
      &:hover {
        background: @blue;
      }
      // &.active {
      //   background: #4a6aff;
      // }
      > img {
        width: 20px;
        height: 20px;
        margin-left: 15px;
      }
      > span {
        font-size: 14px;
        font-weight: 400;
        color: @white;
        line-height: 14px;
        margin-left: 10px;
        margin-right: 20px;
      }

      > .icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
